(function () {
  'use strict';

  function initDrawerNavigation() {
    var container = document.getElementById('drawer-panels');
    if (!container) return;

    var backBtn = document.getElementById('drawer-back-btn');
    var backTitle = document.getElementById('drawer-panel-title');
    var level3BackBtn = document.getElementById('drawer-level3-back-btn');
    var level3BackTitle = document.getElementById('drawer-level3-panel-title');

    var triggersL2 = container.querySelectorAll('[data-trigger-submenu]');
    var submenusL2 = container.querySelectorAll('.drawer-submenu-list');
    var triggersL3 = container.querySelectorAll('[data-trigger-subsubmenu]');
    var submenusL3 = container.querySelectorAll('.drawer-sub-submenu-list');

    // Handle Open Sub-menu (Level 1 -> Level 2)
    triggersL2.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-trigger-submenu');
        var parentTitle = trigger.getAttribute('data-parent-title') || 'BACK';

        submenusL2.forEach(function (menu) {
          menu.style.display = 'none';
        });

        var targetMenu = document.getElementById(targetId);
        if (targetMenu) {
          targetMenu.style.display = 'block';
        }

        if (backTitle) {
          backTitle.textContent = parentTitle.toUpperCase();
        }

        container.setAttribute('data-panel', '2');
      });
    });

    // Handle Open Sub-submenu (Level 2 -> Level 3)
    triggersL3.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-trigger-subsubmenu');
        var parentTitle = trigger.getAttribute('data-parent-title') || 'BACK';

        submenusL3.forEach(function (menu) {
          menu.style.display = 'none';
        });

        var targetMenu = document.getElementById(targetId);
        if (targetMenu) {
          targetMenu.style.display = 'block';
        }

        if (level3BackTitle) {
          level3BackTitle.textContent = parentTitle.toUpperCase();
        }

        container.setAttribute('data-panel', '3');
      });
    });

    // Handle Back Button click (Level 2 -> Level 1)
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        container.setAttribute('data-panel', '1');
      });
    }

    // Handle Back Button click (Level 3 -> Level 2)
    if (level3BackBtn) {
      level3BackBtn.addEventListener('click', function () {
        container.setAttribute('data-panel', '2');
      });
    }

    // Optional: Reset back to Panel 1 when drawer is closed
    var navClose = document.getElementById('nav-close');
    var overlay = document.querySelector('.mobile-nav__overlay');
    
    function resetPanel() {
      setTimeout(function () {
        container.setAttribute('data-panel', '1');
      }, 350);
    }

    if (navClose) {
      navClose.addEventListener('click', resetPanel);
    }
    if (overlay) {
      overlay.addEventListener('click', resetPanel);
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerNavigation);
  } else {
    initDrawerNavigation();
  }
})();
